import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Typography } from 'antd'
import { formatAmount } from '../../../shared/utils/currencies'
import { useTranslation } from 'react-i18next'

const AmountBoxTooltip = ({ amount, box, amountBox, minAmount, tooltip = true }) => {
  const { t } = useTranslation()

  return tooltip ? (
    <Tooltip
      title={t('app.boxAmount', {
        val: formatAmount(amountBox || (box ? amount / box : 0) || 0)
      })}
    >
      <Typography.Text strong type={!amount || (minAmount && amount < minAmount) ? 'danger' : 'success'}>
        {formatAmount(amount)}
      </Typography.Text>
    </Tooltip>
  ) : (
    <Typography.Text strong type={!amount || (minAmount && amount < minAmount) ? 'danger' : 'success'}>
      {formatAmount(amount)}
      {(!box || box === 1) && (!amountBox || amountBox === amount)
        ? null
        : ` ~ ${t('app.boxAmount', {
            val: formatAmount(amountBox || (box ? amount / box : 0) || 0)
          })}`}
    </Typography.Text>
  )
}

AmountBoxTooltip.propTypes = {
  amount: PropTypes.number,
  box: PropTypes.number,
  minAmount: PropTypes.number,
  amountBox: PropTypes.number
}

export default AmountBoxTooltip
